import React from 'react';

export type ErrorSummaryProps = {
    title?: string;
    errors?: Array<string | undefined>;
    className?: string;
};

const ErrorSummary = ({
    title,
    errors,
    className
}: ErrorSummaryProps): JSX.Element => {
    const mappedErrors = errors?.map((error, index) => {
        return <li key={index}>{error}</li>;
    });

    const getClassName = () => {
        if (className === undefined) {
            return 'alert alert-danger';
        }
        return `alert alert-danger ${className}`;
    };

    const renderErrorPanel = () => {
        return (
            <div className={getClassName()} role='alert'>
                {title && <h4>{title}</h4>}
                <ul>{mappedErrors}</ul>
            </div>
        );
    };

    const errorPanel = errors && errors.length > 0 ? renderErrorPanel() : <></>;

    return <>{errorPanel}</>;
};

export default ErrorSummary;
